(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows/assets/javascripts/animations/core.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows/assets/javascripts/animations/core.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
svs.tur.ball.rows.animations = svs.tur.ball.rows.animations || {};
const Events = svs.tur.ball.constants;
svs.tur.ball.rows.animations.DURATION = -1; 

class Core {
  in(_ref) {
    let rows = _ref.rows;
    let eventSent = false;
    const tl = gsap.timeline({
      onUpdate: () => {
        const tlProgress = Math.round(tl.progress() * 100) / 100;
        if (!eventSent && tlProgress >= 0.8) {
          eventSent = true;
          rows.trigger(Events.ANIMATION_ALMOST_DONE, rows);
        }
      }
    });
    tl.fromTo(rows.$el, 0.3, {
      opacity: 0,
      scale: 0.5
    }, {
      opacity: 1,
      scale: 1,
      ease: 'back.out'
    });
    const rowCount = rows.rows.length;
    rows.rows.forEach(row => {
      let rowAnimation;
      if (rowCount <= 3) {
        rowAnimation = row.rollIn();
        tl.add(rowAnimation, '<.2');
      } else {
        rowAnimation = row.slideIn();
        tl.add(rowAnimation, "<".concat(rowCount > 10 ? 0.05 : 0.1));
      }
    });
    return tl;
  }
  rollIn(_ref2) {
    let rows = _ref2.rows;
    let eventSent = false;
    const tl = gsap.timeline({
      onUpdate: () => {
        const tlProgress = Math.round(tl.progress() * 100) / 100;
        if (!eventSent && tlProgress >= 0.7) {
          eventSent = true;
          rows.trigger(Events.ANIMATION_ALMOST_DONE, rows);
        }
      }
    });
    tl.fromTo(rows.$el, 0.3, {
      opacity: 0,
      scale: 0.5
    }, {
      opacity: 1,
      scale: 1,
      ease: 'back.out'
    });

    rows.rows.forEach((row, i) => {
      const animation = row.rollIn();
      tl.add(animation, '<.2');
      if (rows.rows.length > 5) {
        tl.timeScale(1.3);
      }
      if (rows.rows.length > 10) {
        tl.timeScale(1.5);
      }
    });
    return tl;
  }
  slideIn(_ref3) {
    let rows = _ref3.rows,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? svs.tur.ball.rows.animations.DURATION : _ref3$duration;
    let eventSent = false;
    const tl = gsap.timeline({
      onUpdate: () => {
        const tlProgress = Math.round(tl.progress() * 100) / 100;
        if (!eventSent && tlProgress >= 0.7) {
          eventSent = true;
          rows.trigger(Events.ANIMATION_ALMOST_DONE, rows);
        }
      }
    });
    tl.fromTo(rows.$el, {
      opacity: 0,
      scale: 0.5
    }, {
      duration: 0.3,
      opacity: 1,
      scale: 1,
      ease: 'back.out'
    });
    rows.rows.forEach(row => {
      const animation = row.slideIn();
      tl.add(animation, '<.2');
    });
    if (duration > svs.tur.ball.rows.animations.DURATION) {
      tl.duration(duration);
    }
    return tl;
  }
}
svs.tur.ball.rows.animations.Core = new Core();

 })(window);